import { useEffect } from 'react';
import React from 'react';
import SafeImage from '../images/safe.png';
import './saftey.css';

const SafteryAssurance = () => {

    return (
        <div className='saftey'>
            <div className="container saftey_container">
                <div className="saftey_header">
                    <h1>We use safe and environmentally friendly products.</h1>
                    <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                </div>
                <div className="saftery_image">
                    <img src={SafeImage} alt="" />
                </div>
            </div>
        </div>
    )
}

export default SafteryAssurance